/** Recently-opened courses — the dashboard «درس‌های فعال» widget shows the 3
 *  courses the user actually opened last (device-local history), falling back
 *  to the default order when there is no history yet. */

export const RECENT_COURSES_KEY = "nelurio.courses.recent.v1";
export const RECENT_COURSES_CAP = 10;

export function readRecentCourseIds(store: Pick<Storage, "getItem"> | null = typeof window === "undefined" ? null : window.localStorage): string[] {
  try {
    const value = JSON.parse(store?.getItem(RECENT_COURSES_KEY) ?? "[]");
    return Array.isArray(value) ? value.filter((id) => typeof id === "string") : [];
  } catch {
    return [];
  }
}

/** Register an open: the id moves to the front, duplicates collapse, history
 *  is capped. Returns the stored list (newest first). */
export function recordCourseOpen(courseId: string, store: Pick<Storage, "getItem" | "setItem"> | null = typeof window === "undefined" ? null : window.localStorage): string[] {
  const next = [courseId, ...readRecentCourseIds(store).filter((id) => id !== courseId)].slice(0, RECENT_COURSES_CAP);
  try { store?.setItem(RECENT_COURSES_KEY, JSON.stringify(next)); } catch { /* private mode */ }
  return next;
}

/**
 * Dashboard order: recently-opened courses first (in recency order), then the
 * remaining courses in their original order. Deleted courses vanish naturally.
 */
export function orderCoursesByRecency<T extends { id: string }>(courses: T[], recentIds: string[]): T[] {
  const byId = new Map(courses.map((course) => [course.id, course]));
  const ordered: T[] = [];
  for (const id of recentIds) {
    const course = byId.get(id);
    if (course) {
      ordered.push(course);
      byId.delete(id);
    }
  }
  return [...ordered, ...byId.values()];
}

/** The widget's pick: up to n courses, recency first. */
export function topRecentCourses<T extends { id: string }>(courses: T[], recentIds: string[], n = 3): T[] {
  return orderCoursesByRecency(courses, recentIds).slice(0, n);
}
